// Compatibility with some old browser
import {StepindexComponentComponent} from "../output/output.stepindex.component";

if(window.console && !window.console.debug) {
    window.console.debug = function(message: any) {console.log(message);}
}
if(window.console && !window.console.error) {
    window.console.error = function(message: any) {console.log(message);}
}
if(window.console && !window.console.info) {
    window.console.info = function(message: any) {console.log(message);}
}

// Angular
import {APP_INITIALIZER, NgModule, LOCALE_ID, ApplicationRef, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import * as Sentry from "@sentry/angular";

// Import and register additional locales
import {registerLocaleData} from "@angular/common";
import localeDE from '@angular/common/locales/de';
import localeFR from '@angular/common/locales/fr';
import localeES from '@angular/common/locales/es';
import localeEN from '@angular/common/locales/en';

/**
 * returns the users locale from the browser
 *
 * @returns {string}
 */
function initLocale() {
    let locale = 'en';
    if (navigator["browserLanguage"]) {
        locale = navigator["browserLanguage"];
    }
    else if (navigator.language) {
        locale = navigator.language;
    }
    switch(locale.substring(0,2)) {
        case 'gs':
        case 'ks':
            // workaround for ksh and gsw
            locale = 'de';
        case 'de':
            registerLocaleData(localeDE, 'de');
            break;
        case 'fr':
            registerLocaleData(localeFR, 'fr');
            break;
        case 'es':
            registerLocaleData(localeES, 'es');
            break;
        default:
            registerLocaleData(localeEN, locale.substring(0,2));
            locale = 'en';
            break;
    }
    return locale;
}

// vendors
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

// own components, classes
import { DonationComponent }   from './donation.component';
import { RythmTargetComponent } from '../rythm_target/rythm_target.component';
import { PaymentComponent } from '../payment/payment.component';
import { AmountComponent } from '../amount/amount.component';
import { RadioComponent } from '../input/input.radio.component';
import { TextfieldComponent } from '../input/input.textfield.component';
import { CheckboxButtonComponent } from '../input/input.checkbox_button.component';
import { SubmitComponent } from '../input/input.submit.component';
import { ContactComponent } from '../contact/contact.component';
import { ProgressComponent } from '../output/output.progress.component';
import { ShareComponent } from '../share/share.component';
import { BanktransferComponent } from '../output/output.banktransfer.component';
import { HeadlineComponent } from "../output/output.headline.component";
import { StatusComponent } from "../output/output.status.component";
import { CopyfieldComponent } from "../output/output.copyfield.component";
import {TrackingComponent} from "../tracking/tracking.component";
import {StepNavigationComponent} from "../step/step.navigation";
import {PaymentIframeComponent} from "../payment/payment.iframe.component";
import {SafeUrlPipe} from "../pipe/safeUrl.pipe";
import {ThankyouComponent} from "../output/output.thankyou.component";
import {SelectCountryComponent} from "../input/input.select.country.component";
import {FooterdataComponent} from "../output/output.footerdata.component";
import {FullscreenTextComponent} from "../output/output.fullscreentext.component";
import {HiddenFormsubmitComponent} from "../input/input.hidden.formsubmit.component";
import {DoiComponent} from "../doi/doi.component";
import {TwingleTranslationPipe} from "../translation/twingle.translation.pipe";
import {EncodeUriPipe} from "../pipe/encodeURI.pipe";
import {ExtrafieldComponent} from "../output/output.extrafield.component";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {CheckboxComponent} from "../input/input.checkbox.component";
import {PageHeaderComponent} from "../page/page.header";
import {EventHeaderComponent} from "../event/event.header";
import {DonatorComponent} from "../donator/donator.component";
import {MessagefieldComponent} from "../input/input.messagefield.component";
import {ProjectDonatorsComponent} from "../output/output.project-donators.component";
import {GiftDonationdataComponent} from "../gift/gift.donationdata";
import {Nl2BrPipe} from "../pipe/nl2Br.pipe";
import {AmountImageComponent} from "../amount/amount.image.component";
import {RadioSimpleComponent} from "../input/input.radio_simple.component";
import {TwingleTranslationLoader} from "../translation/twingle.translation.loader";
import {InputRemarksComponent} from "../input/input.remarks.component";
import {AdditionalfieldsComponent} from "../additionalfields/additionalfields.component";
import {AmountExtraComponent} from "../amount/amount.extra.component";
import {PaymentIconsComponent} from "../payment/payment.icons.component";
import {StripHtmlPipe} from "../pipe/stripHtml.pipe";
import {BonusComponent} from "../bonus/bonus.component";
import {PaymentPreviewComponent} from "../payment/payment.preview.component";
import {ThankyouOrderHeadlineComponent} from '../thankyou-order/thankyou-order.headline.component';
import {ThankyouOrderTextComponent} from '../thankyou-order/thankyou-order.text.component';
import {ThankyouOrderMediaComponent} from '../thankyou-order/thankyou-order.media.component';
import {NewsletterComponent} from '../newsletter/newsletter.component';
import {ThankyouOrderComponent} from '../thankyou-order/thankyou-order.component';
import {InputSalutationComponent} from "../input/input.salutation.component";
import {InputCheckboxToggleComponent} from "../input/input.checkbox.toggle.component";
import {SelectComponent} from "../input/input.select.component";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TwingleTranslationLoader(http, __twingle_translationUrl.replace(/language\.json/, ''), '.json');
}

// declare global vars
declare let __twingle_translationUrl: string;

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [DonationComponent, RadioComponent, CheckboxButtonComponent, RadioSimpleComponent, TextfieldComponent, MessagefieldComponent, RythmTargetComponent, PaymentComponent, PaymentIconsComponent, AmountComponent, AmountExtraComponent,
        ProgressComponent, SubmitComponent, ContactComponent, ShareComponent, BanktransferComponent, HeadlineComponent, StatusComponent, BonusComponent, SelectComponent,
        CopyfieldComponent, TrackingComponent, PageHeaderComponent, EventHeaderComponent, StepNavigationComponent, PaymentIframeComponent, SafeUrlPipe, ThankyouComponent,
        SelectCountryComponent, FooterdataComponent, FullscreenTextComponent, HiddenFormsubmitComponent, DoiComponent, TwingleTranslationPipe, EncodeUriPipe, Nl2BrPipe, StripHtmlPipe,
        ExtrafieldComponent, CheckboxComponent, DonatorComponent, ProjectDonatorsComponent, GiftDonationdataComponent, StepindexComponentComponent, AmountImageComponent, InputRemarksComponent, AdditionalfieldsComponent, PaymentPreviewComponent,
        ThankyouOrderHeadlineComponent, ThankyouOrderTextComponent, ThankyouOrderMediaComponent, NewsletterComponent, ThankyouOrderComponent, InputSalutationComponent, InputCheckboxToggleComponent
    ],
    exports: [DonationComponent, RadioComponent, CheckboxButtonComponent, RadioSimpleComponent, TextfieldComponent, MessagefieldComponent, RythmTargetComponent, PaymentComponent, PaymentIconsComponent, AmountComponent, AmountExtraComponent,
        ProgressComponent, SubmitComponent, ContactComponent, ShareComponent, BanktransferComponent, HeadlineComponent, StatusComponent, BonusComponent, AdditionalfieldsComponent,
        CopyfieldComponent, TrackingComponent, PageHeaderComponent, EventHeaderComponent, StepNavigationComponent, PaymentIframeComponent, SafeUrlPipe, ThankyouComponent,
        SelectCountryComponent, FooterdataComponent, FullscreenTextComponent, HiddenFormsubmitComponent, DoiComponent, TwingleTranslationPipe, EncodeUriPipe, Nl2BrPipe, SelectComponent,
        ExtrafieldComponent, CheckboxComponent, DonatorComponent, ProjectDonatorsComponent, GiftDonationdataComponent, StepindexComponentComponent, AmountImageComponent, InputRemarksComponent, PaymentPreviewComponent,
        ThankyouOrderHeadlineComponent, ThankyouOrderTextComponent, ThankyouOrderMediaComponent, NewsletterComponent, ThankyouOrderComponent, InputSalutationComponent, InputCheckboxToggleComponent
    ],
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        { provide: LOCALE_ID, useValue: initLocale() }
    ]
})
export class DonationModule {
    /**
     * Methods controlls which component to bootstrap
     * @param appRef
     */
    ngDoBootstrap(appRef:ApplicationRef){
        if(document.getElementsByTagName("donation-app").length > 0) {
            appRef.bootstrap(DonationComponent);
        }
        if(document.getElementsByTagName("doi").length > 0) {
            appRef.bootstrap(DoiComponent);
        }
    }
}
